/** Dev / e2e: skip MSAL gate and Header Graph token flow when `VITE_MOCK_AUTH=true`. */
export function isMockAuthEnabled(): boolean {
  return import.meta.env.VITE_MOCK_AUTH === 'true';
}

/** E2E: show dev-only sidebar entries (`/logs`, `/admin-mailing-list`) for the mock Graph user id. */
export function isMockDevMenuEnabled(): boolean {
  return import.meta.env.VITE_MOCK_DEV_MENU === 'true';
}
